module.exports = __webpack_public_path__ + "img/C.511233dd.png";